import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import qs from 'qs';

import Layout from 'components/common/Layout';
import SignUpCompany from 'components/account/SignUpCompany';
import AccountNavigation from 'components/account/AccountNavigation';
import AccountLogo from 'components/account/AccountLogo';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import tidioSrc from 'config/tidioSrc';

class AccountSignUp extends Component {
  componentDidMount() {
    const { history } = this.props;
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('page-with-tidio');
    if (!history.location.state || !history.location.state.email) {
      history.replace('/account/login');
    }
  }

  componentWillUnmount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('page-with-tidio');
  }

  render() {
    const { history } = this.props;
    const signUpParams = qs.stringify({
      signup: true,
    }, {
      encode: false, addQueryPrefix: true,
    });
    return (
      <Layout variant="account-login">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Sign Up
          </title>
          <script src={tidioSrc} async />
        </Helmet>
        <AccountLogo />
        <SignUpCompany
          form="signUpCompanyForm"
          initialValues={{
            Email: history.location.state.email,
            'Signer Gender': 'Other',
          }}
          onSubmitSuccess={(values) => {
            const redirectOrigin = new URL(values.url).origin;
            window.location.replace(`${redirectOrigin}${signUpParams}`);
          }}
        />
        <AccountNavigation />
      </Layout>
    );
  }
}

AccountSignUp.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export default AccountSignUp;



// WEBPACK FOOTER //
// ./src/pages/account/AccountSignUpCompany.js